<template>
    <div class="pda-default">
        <!-- {{isBeforeConfirm}} -->
        <div class="exam-view-detail" v-if="!isBeforeConfirm">
            <!-- <div class="t-body1">
                    {{paperName}}
            </div> -->
            <div class="mdc-card mdc-elevation--z3">
               
                <div class=" pdl-16 pdr-16 pdt-16 pdb-16 position-relative">
                     <!-- <div class="dotted-line position-absolute"></div> -->
                    <!-- static data added  -->
                     <div class="percentage-wrapper">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="t-color-lecturePurple t-helper">{{$t('79')}}</div>
                            <div class="d-flex align-items-baseline">
                                <div class="percent-number t-color-lecturePurple t-subtitle1 l-spacing6 font-b mgr-4" >{{`${score}`}}</div>
                                 
                                <div class="t-color-lecturePurple t-caption">{{$t('91', {str: ''})}}</div>
                            </div>
                        </div>
                        <div class="h-2 position-relative total-percentage mgb-12">
                            <div class="real-percentage bg-lecturePurple h-6 " :style="`width:${score}%;`"></div>
                        </div>
                    </div>
                    <div class="percentage-wrapper">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="t-color-textfieldGuid t-helper"> {{$t('80')}}</div>
                            <div class="d-flex align-items-baseline">
                                <div class="percent-number t-color-textfieldGuid t-subtitle1 l-spacing6 font-b mgr-4" >{{`${averageScore}`}}</div>
                                <div class="t-color-textfieldGuid t-caption">{{$t('91', {str: ''})}}</div>
                            </div>
                        </div>
                        <div class="h-2 position-relative total-percentage mgb-12">
                            <div class="real-percentage bg-textfieldGuid h-6 " :style="`width:${averageScore}%;`"></div>
                        </div>
                    </div>
                    <!-- static data ends -->
                    
                    <!-- <div class="d-flex flex-row justify-content-between align-items-center graph-row">
                        <div class="t-helper mgl-8 mgr-8 w-70">
                            {{$t('79')}} -->
                            <!-- 나의 점수 -->
                        <!-- </div>
                        <div class="flex-grow-1 d-flex flex-row justify-content-between align-items-center h-full">
                            <div class="rowline"></div>
                            <div class="flex-grow-1 graph d-flex align-items-center">
                                <div class="guideline"></div>
                                <div class="pointline" :style="`width:${score}%;`"></div>
                            </div>
                        </div>
                        <div class="t-headline5 mgl-8 mgr-8 w-50 d-flex flex-row-reverse">
                            {{score}} -->
                            <!-- 100 -->
                        <!-- </div>
                    </div>

                    <div class="d-flex flex-row justify-content-between align-items-center graph-row other">
                        <div class="t-helper mgl-8 mgr-8 w-70">
                            {{$t('80')}} -->
                            <!-- 동료 평균 -->
                        <!-- </div>
                        <div class="flex-grow-1 d-flex flex-row justify-content-between align-items-center h-full">
                            <div class="rowline"></div>
                            <div class="flex-grow-1 graph d-flex align-items-center">
                                <div class="guideline"></div>
                                <div class="pointline other" :style="`width:${averageScore}%;`"></div>
                            </div>
                        </div>
                        <div class="t-headline5 mgl-8 mgr-8 w-50 d-flex flex-row-reverse">
                            {{averageScore}} -->
                            <!-- 100 -->
                        <!-- </div>
                    </div> -->
                    
                    
                </div>
            </div>

            <div class="mgt-16 d-grid-3 t-body3">
                <div class="mdc-card mdc-elevation--z2 pda-default t-center">
                    <div class="t-headline9">
                        {{countTotal}}
                    </div>
                    <div class="t-color-bodyGrayA mgt-16">
                        {{$t('81')}}
                        <!-- 시험 문항 수 -->
                    </div>
                </div>
                <div class="mdc-card mdc-elevation--z2 pda-default t-center">
                    <div class="t-headline9">
                        {{countCorrect}}
                    </div>
                    <div class="t-color-bodyGrayA mgt-16">
                        {{$t('82')}}
                        <!-- 정답 개수 -->
                    </div>
                </div>
                <div class="mdc-card mdc-elevation--z2 pda-default t-center">
                    <div class="t-headline9">
                        {{countIncorrect}}
                    </div>
                    <div class="t-color-bodyGrayA mgt-16">
                        {{$t('83')}}
                        <!-- 오답 개수 -->
                    </div>
                </div>
            </div>

            <div class="mgt-16">
                <div class="mdc-card mdc-elevation--z2">
                    <div class="t-color-bodyGrayA d-flex flex-row justify-content-between align-items-center">
                        <div class="mgr-16 mgl-16">
                            {{$t('84')}}
                            <!-- 문항별 결과 -->
                        </div>
                        <div>
                            <button class="mdc-icon-button material-icons mdc-card__action mdc-card__action--icon--unbounded" @click="toggleQuestionViewStatus()">
                                {{questionViewStatus ? 'expand_less' : 'expand_more'}}
                            </button>
                        </div>
                    </div>
                    <div class="mgr-16 mgl-16 pdb-10 d-grid-5 t-color-disableBtn" v-show="questionViewStatus">
                        <div class="t-subtitle2 item t-center pdt-16 pdb-16 position-relative" v-for="(question, index) in questions" :key="index">
                            <div class="question-correct" :class="question.correct === true ? 'question-correct' : 'question-incorrect'"></div>
                            {{index+1}}
                        </div>
                    </div>
                </div>
                
            </div>

            <div>
                <div v-for="(action, index) in examActions" :key="index" class="mgt-16">
                    <!-- {{action}} --><!-- {{action}} -->
                    <template v-if="setButtonActionName(action)" >
                    <button class="mdc-button mdc-button--raised btn-red  w-full" :disabled="setButtonDisabled(action)" @click="examAction(action)" v-if="action.action === 'open_confirm'">
                        {{setButtonActionName(action)}}
                    </button>    
                    <button class="mdc-button mdc-button--raised bg-white t-color-secondaryBtnText w-full " :disabled="setButtonDisabled(action)" @click="examAction(action)" v-else>
                        {{setButtonActionName(action)}}
                    </button>  
                    </template>
                </div>
            </div>

            <!-- {{examActions}}
            {{isBeforeConfirm}} -->
            
        </div>
        <div class="pda-default d-flex flex-column justify-content-between align-items-center" v-else>
            <div class="mgt-50 mgb-50">
                <img src="@/images/exam_before_confirm.svg" alt="">
            </div>
            <div class="t-subtitle4">
                {{$t('28')}}    
                <!-- 성적 조회 기간이 아닙니다 -->
            </div>
        </div>
    </div>
</template>

<script>
import examApi from '@/api/examApi.js'
import {examMixin} from '@/mixins/exam.js'
import {MDCRipple} from '@material/ripple'

export default {
    data() {
        return {
            paperName : '',
            examineeId: null,
            countTotal: 0,
            countCorrect: 0,
            countIncorrect: 0,
            scoreMy: 0,
            questions: null,

            questionViewStatus: true,

            examActions: [],
            paperId: 0,

            scoreData: null,
            averageScore: 0,
            standard: 0,
            score: 0,

            applicationEarnPoint: 0,
            solveAllEarnPoint: 0,
            getTotalPoint: 0,
        }
    },

    components: {
        
    },

    mixins: [examMixin],
    
    computed: {
        isBeforeConfirm() {            
            let actionIndex = _.findIndex(this.examActions,(action) => { return action.action === 'before_confirm'})
            return actionIndex >= 0
        }
    },

    mounted() {
        let responseData = null
        this.examineeId = this.$route.params.examineeId
        let params = {
            examineeId: this.examineeId
        }

        examApi.submitedList(params).then((response) => {
            responseData = response.data.data
            // console.log('responseData', responseData)
            
            
            let lastSubmitData = _.head(responseData)
            // console.log('lastSubmitData', lastSubmitData)

            this.paperId = lastSubmitData.id

            params = {
                examineeId: this.examineeId,
                paperId: this.paperId
            }


            examApi.result(params).then((response) => {
                responseData = response.data.data
                console.log('result responseData', responseData)
                this.paperName = responseData.name
                this.countTotal = responseData.count.total
                this.countCorrect = responseData.count.correct
                this.countIncorrect = responseData.count.incorrect

                this.applicationEarnPoint = responseData.applicationEarnPoint
                this.solveAllEarnPoint = responseData.solveAllEarnPoint
                this.getTotalPoint = this.applicationEarnPoint + this.solveAllEarnPoint

                this.scoreMy = responseData.score
                this.examActions = responseData.actions

                this.questions = _.chain(responseData.groups)
                    .map((item) => {
                        return item.questions
                    })
                    .flatten()
                    .map((question, index) => {
                        return question
                    }).value()

                // console.log('this.questions', this.questions);
                
            }).catch((err) => {
                
            })


            examApi.score(params).then((response) => {
                this.scoreData = response.data.data
                console.log('scoreData=>ResultMY', this.scoreData)
                this.averageScore = parseInt(this.scoreData.averageScore)
                this.standard = parseInt(this.scoreData.standard)
                this.score = parseInt(this.scoreData.score)
                

            }).catch((err) => {
                
            })
            


            
            
            

        }).catch((err) => {
            
        })

        // examApi.examIntro(params).then((response) => {
        //     this.examData = response.data.data
        //     //console.log('examIntro', this.examData)
        //     //this.examActions = this.examData.actions

        // }).catch((err) => {
            
        // })
        
        this.setMaterialUi()
    },

    methods: {
        toggleQuestionViewStatus() {
            this.questionViewStatus = !this.questionViewStatus
        },

        setButtonActionName(action) {
            //before_start : ~부터 응시가능
            //can_start : 응시
            //can_re_start : 재응시
            //before_confirm : ~부터 결과확인 가능
            //open_confirm : 결과확인
            let buttonName = ''
            if (action.action === 'before_start') {
                buttonName = this.$t('50010', {str: $moment(action.data.application_start_time).format('L')})    // action.data.application_start_time + '부터 응시가능'
            }else if (action.action === 'can_start') {
                buttonName = this.$t('50008')   //'응시'
            }else if (action.action === 'can_re_start') {
                buttonName = this.$t('86') // '재응시'
            }else if (action.action === 'before_confirm') {
                buttonName = this.$t('50011', {str: $moment(action.data.confirm_start_time).format('L')}) //action.data.confirm_start_time + '~부터 결과확인 가능'
            }else if (action.action === 'open_confirm') {
                buttonName =  this.$t('85') //'결과확인'
            }
            return buttonName
        },

        setButtonDisabled(action) {
            return action.action === 'before_start' || action.action === 'before_confirm' ? true : false
        },

        examAction(action) {
            if (action.action === 'can_start') {
                this.startExam()
            }else if (action.action === 'can_re_start') { 
                this.$router.push({
                    name: 'IndependentExamIntro', 
                    query: this.$route.query
                })
            }else if (action.action === 'open_confirm') {
                //this.startExam()
                //console.log('결과보기로 ㄱㄱ');
                this.moveExamFeedback()
                
            }
        },
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        
    }
}
</script>

<style scoped>

 
  .total-percentage{
      background-color: rgba(172, 180, 190, 0.3);
  }
  .opacity7{
      opacity: 0.7;
  }
  .total-percentage .real-percentage{
      position: absolute;
      left: 0;
      top:-3px;
      border-radius:6px;
      width: 237px;
  }
  .standard-percentage{
      color: var(--Iconinactive);
  }
  .standard-percentage:after {
    content: '';
    position: absolute;
    width: 0;
    height: 68px;
    border: dashed var(--Divider);
    border-width: 0.2px;
    bottom: 20px;
    left: 50%;
  }

  .standard-percentage-wrap{position: relative;width: 100%;padding-bottom: 20px;}
  .standard-percentage-wrap .standard-percentage{
        left: 0%; 
        width:90px;
        position: absolute !important;
    }
    .dotted-line{
        content: '';
        position: absolute;
        width: 0;
        height: 68px;
        border: dashed var(--Divider);
        border-width: 0.2px;
        bottom: 20px;
        left: 50%;
    }

    .exam-view-detail .question-correct {
    background: none;
  
    top: 50%;
    left: 50%;
 
    width: 24px;
    height: 24px;
    border: 3px solid #76a0d6;
    border-radius: 54px;
    transform: translate(-50%,-50%);
    }
    .exam-view-detail .question-incorrect{
        background: none;
  
    top: 50%;
    left: 50%;
 border: none;
    width: 24px;
    height: 24px;
   border-radius: 0px;
    transform: translate(-50%,-50%);
    
    }
   .exam-view-detail .question-incorrect:after {
    content: '';
    height: 24px;
    border-left: 2px solid #f16d70;
    position: absolute;
    transform: rotate(45deg);
   
}

.exam-view-detail .question-incorrect:before {
    content: '';
    height: 24px;
    border-left: 2px solid #f16d70;
    position: absolute;
    transform: rotate(-45deg);
    
}
  
</style>